export const isMobileSize = (width: number) => width <= 550;
